import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const ContactsCleanerPrivacyPolicy = () => {
    return (
        <div className="min-h-screen bg-gray-50">
            <Navbar />
            <div className="max-w-4xl mx-auto px-4 py-8 md:py-12 mt-16">
                <div className="bg-white rounded-lg shadow-sm p-8 md:p-12">
                    <header className="mb-8 border-b pb-8">
                        <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
                            Privacy Policy for Contacts Cleaner
                        </h1>
                        <p className="text-gray-600">Last updated: January 19, 2026</p>
                    </header>
                    <div className="prose prose-blue max-w-none text-gray-700 space-y-6">
                        <section className="mb-8">
                            <p className="mb-4">
                                This Privacy Policy describes Our policies and procedures on the collection, use and
                                disclosure of Your information when You use the Service and tells You about Your
                                privacy rights and how the law protects You.
                            </p>
                            <p>
                                We prioritize your privacy above all else. Unlike many other apps, <strong>Contacts Cleaner
                                    operates entirely offline</strong>. We do not collect, store, or transmit your contact data
                                to any external servers. All processing happens locally on your device.
                            </p>
                        </section>
                        <section className="mb-8">
                            <h2 className="text-2xl font-semibold text-gray-800 mb-4">
                                Interpretation and Definitions
                            </h2>
                            <h3 className="text-xl font-medium text-gray-800 mb-3">Interpretation</h3>
                            <p>
                                The words of which the initial letter is capitalized have meanings defined under the
                                following conditions. The following definitions shall have the same meaning
                                regardless of whether they appear in singular or in plural.
                            </p>
                            <h3 className="text-xl font-medium text-gray-800 mb-3 mt-6">Definitions</h3>
                            <p className="mb-2">For the purposes of this Privacy Policy:</p>
                            <ul className="list-disc pl-6 space-y-2">
                                <li>
                                    <strong>Application</strong> refers to Contacts Cleaner, the software program
                                    provided by the Company.
                                </li>
                                <li>
                                    <strong>Company</strong> (referred to as either "the Company", "We", "Us" or
                                    "Our" in this Agreement) refers to Apptek.
                                </li>
                                <li><strong>Country</strong> refers to: Denmark</li>
                                <li>
                                    <strong>Device</strong> means any device that can access the Service such as a
                                    computer, a cellphone or a digital tablet.
                                </li>
                                <li>
                                    <strong>Personal Data</strong> is any information that relates to an identified
                                    or identifiable individual.
                                </li>
                                <li><strong>Service</strong> refers to the Application.</li>
                                <li>
                                    <strong>You</strong> means the individual accessing or using the Service, or the
                                    company, or other legal entity on behalf of which such individual is accessing
                                    or using the Service, as applicable.
                                </li>
                            </ul>
                        </section>
                        <section className="mb-8">
                            <h2 className="text-2xl font-semibold text-gray-800 mb-4">
                                Collection and Use of Your Data
                            </h2>
                            <h3 className="text-xl font-medium text-gray-800 mb-3">Types of Data Collected</h3>

                            <h4 className="text-lg font-medium text-gray-800 mb-2 mt-4">Contact Information</h4>
                            <p className="mb-2">
                                Our Application requires access to your device's Address Book (Contacts) to function.
                                We use this access strictly to:
                            </p>
                            <ul className="list-disc pl-6 space-y-2">
                                <li>Display your contacts within the app.</li>
                                <li>Allow you to organize, delete, or merge duplicate contacts.</li>
                                <li>Create local backups (VCF files) of your contacts.</li>
                            </ul>
                            <p className="mt-4 font-semibold">
                                We do not upload your contacts to any server. Your contact data never leaves your device.
                            </p>

                            <h4 className="text-lg font-medium text-gray-800 mb-2 mt-4">Usage Data</h4>
                            <p className="mb-2">
                                We do not collect any personal usage data. We do not use third-party analytics
                                services (like Google Analytics or Firebase) to track your behavior within the app.
                            </p>
                        </section>

                        <section className="mb-8">
                            <h2 className="text-2xl font-semibold text-gray-800 mb-4">Third-Party Services</h2>
                            <p className="mb-2">
                                The Application does not integrate with any third-party data collection services.
                            </p>
                            <p className="mt-2">
                                However, please note that the Application is distributed via the Apple App Store
                                and Google Play Store, which may collect their own usage statistics in accordance
                                with their respective privacy policies.
                            </p>
                        </section>

                        <section className="mb-8">
                            <h2 className="text-2xl font-semibold text-gray-800 mb-4">
                                Legal Basis for Processing (GDPR)
                            </h2>
                            <p className="mb-2">We process your data under the following legal basis:</p>
                            <ul className="list-disc pl-6 space-y-2">
                                <li>
                                    <strong>Consent:</strong> You explicitly grant the Application permission to
                                    access your contacts via your device's operating system settings. You can revoke
                                    this permission at any time.
                                </li>
                            </ul>
                        </section>

                        <section className="mb-8">
                            <h2 className="text-2xl font-semibold text-gray-800 mb-4">Delete Your Personal Data</h2>
                            <p className="mb-4">
                                Since we do not store your data on our servers, there is no account to delete. If
                                you wish to stop using the Service, you can simply uninstall the Application and
                                revoke contact permissions in your device settings.
                            </p>
                        </section>

                        <section className="mb-8">
                            <h2 className="text-2xl font-semibold text-gray-800 mb-4">Security of Your Data</h2>
                            <p>
                                The security of Your data is paramount. By keeping all your data locally on your
                                device, we eliminate the risk of remote data breaches associated with cloud storage.
                            </p>
                        </section>

                        <section className="mb-8">
                            <h2 className="text-2xl font-semibold text-gray-800 mb-4">Children’s Privacy</h2>
                            <p>
                                Our Service is not intended for children under 4 years of age. We do not
                                knowingly collect Personal Data from children.
                            </p>
                        </section>

                        <section className="mb-8">
                            <h2 className="text-2xl font-semibold text-gray-800 mb-4">Changes to this Privacy Policy</h2>
                            <p className="mb-4">
                                We may update Our Privacy Policy from time to time. We will notify You of any
                                changes by posting the new Privacy Policy on this page.
                            </p>
                        </section>

                        <section className="mb-8">
                            <h2 className="text-2xl font-semibold text-gray-800 mb-4">Contact Us</h2>
                            <p className="mb-2">
                                If You have any questions about this Privacy Policy, You can contact us:
                            </p>
                            <ul className="list-disc pl-6 space-y-2">
                                <li>By email: legal@apptek.dev</li>
                            </ul>
                        </section>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
};

export default ContactsCleanerPrivacyPolicy;
